import { PartnerPageData } from 'types/types'
import { getCorrectMainFont } from './getCorrectMainFont'

/**
 * Check if the current page is a Star Sports page
 */
export const isStarSportsPage = (page: PartnerPageData | null | undefined): boolean => {
  return page?.feature_flags?.is_star_sports_page ?? false
}

/**
 * Get the Star Sports blue color (#13294b) or fallback to primary button color
 */
export const getStarSportsColor = (page: PartnerPageData | null | undefined): string => {
  return isStarSportsPage(page) ? '#13294b' : page?.primary_button_color ?? '#353535'
}

export const getStarSportsFontSize = (
  page: PartnerPageData | null | undefined,
  fontSize: number,
): number => {
  return isStarSportsPage(page) ? fontSize * 1.5 : fontSize
}

/**
 * Get font family for Star Sports pages (Coluna Rounded) or fallback
 */
export const getStarSportsFont = (page: PartnerPageData | null | undefined): string => {
  if (!page) return 'Montserrat'
  return isStarSportsPage(page) ? getCorrectMainFont(page) : 'Montserrat'
}

/**
 * Get font style for Star Sports pages (normal) or fallback (italic)
 */
export const getStarSportsFontStyle = (
  page: PartnerPageData | null | undefined,
  defaultStyle: 'normal' | 'italic' = 'italic',
): 'normal' | 'italic' => {
  return isStarSportsPage(page) ? 'normal' : defaultStyle
}

export const getStarSportsHeaderText = (page: PartnerPageData | null | undefined): string => {
  if (!page) return ''
  return page.header_line_1
}

/**
 * Get text color for Star Sports footer (white) or fallback
 */
export const getStarSportsFooterColor = (page: PartnerPageData | null | undefined): string => {
  return isStarSportsPage(page) ? '#ffffff' : page?.footer_text_color ?? '#353535'
}

/**
 * Get shadow color for Star Sports selection (blue #13294b) or fallback
 */
export const getStarSportsShadowColor = (
  page: PartnerPageData | null | undefined,
  defaultColor: string,
): string => {
  return isStarSportsPage(page) ? '#13294b' : defaultColor
}

export const getStarSportsMenuItemColor = (page: PartnerPageData | null | undefined): string => {
  return isStarSportsPage(page) ? '#13294b' : page?.game_page_second_header_color ?? '#353535'
}

export const getStarSportsFooterWording = (page: PartnerPageData | null | undefined): string => {
  return isStarSportsPage(page) ? '*Terms & Conditions' : 'Terms & Conditions'
}
